import { render } from "./MenuNavigation.vue?vue&type=template&id=63042d6d&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"

import "./MenuNavigation.vue?vue&type=style&index=0&id=63042d6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63042d6d"]])

export default __exports__